/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { useInitial } from 'hooks';
import { useSelector } from 'react-redux';
import { getGlobal, getPersonsLoaded } from 'store';
import { Styles } from 'Styles';
import Scene from 'containers/Scene';

interface Props {
  width: string;
  height: string;
}

function App(props: Props) {
  useInitial(parseInt(props.width, 10), parseInt(props.height, 10));
  const [play, setPlay] = useState(false);

  const { height, width } = useSelector(getGlobal);
  const isPersonsLoaded = useSelector(getPersonsLoaded);

  return (
    <>
      <Styles />
      <div
        className="container"
        onClick={() => {
          setPlay(true);
          const ev = new CustomEvent('customEvent');
          window.dispatchEvent(ev);
        }}
      >
        {play || !isPersonsLoaded ? null : (
          <div
            className="overlapBlock"
            style={{
              height,
              width,
            }}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <button type="button" className="playBtn">
              Click to play
            </button>
          </div>
        )}
        <Scene play={play} />
      </div>
    </>
  );
}

export default App;
